import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import {
  FaStar,
  FaArrowLeft,
  FaArrowRight,
  FaTimes,
  FaPlus,
  FaMinus,
} from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { addToCart, getCartCount } from "../../../utils/cartUtils";
import { LiaTimesSolid } from "react-icons/lia";
import { TfiRulerAlt } from "react-icons/tfi";


const styles = `
  @keyframes wiggle {
    0%, 100% { transform: translateX(0); }
    25% { transform: translateX(-3px); }
    50% { transform: translateX(3px); }
    75% { transform: translateX(-3px); }
  }
  .wiggle {
    animation: wiggle 0.2s ease-in-out 3;
  }
  .disabled-overlay::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 8%;
    right: 8%;
    height: 1px;
    background-color: #9ca3af; /* gray-400 */
    transform: translateY(-50%);
    pointer-events: none;
  }
`;

const Recommended2 = ({ data }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [themeColor, setThemeColor] = useState("#fdfd96");
  const swiperRef2 = useRef(null);
  const [commonSubCategoryAutoId, setCommonSubCategoryAutoId] = useState("");
  const [commonSubCategoryName, setCommonSubCategoryName] = useState("");
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedSizeId, setSelectedSizeId] = useState(null);
  const [selectedStock, setSelectedStock] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [selectedSizePrice, setSelectedSizePrice] = useState(null);
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();
  const [chartImage, setChartImage] = useState(null);
  const [chartImage2, setChartImage2] = useState(null);
  const admin_auto_id = sessionStorage.getItem('admin_auto_id');
  const app_type_id = sessionStorage.getItem('app_type_id');
  const [showSizeChart, setShowSizeChart] = useState(false);
  const [isQuantityLeftFactual, setIsQuantityLeftFactual] = useState(false);
  const [quantityLeftFactualValue, setQuantityLeftFactualValue] = useState(1);
  const [showStock, setShowStock] = useState(false);
  const [randomStocks, setRandomStocks] = useState([]);
  const [isMarketingKeysLoading, setIsMarketingKeysLoading] = useState(true);


  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  const clearMessage = () => {
    setTimeout(() => {
      setMessage(null);
    }, 2000); // Clear message after 2 seconds
  };

  useEffect(() => {
    if (products.length > 0) {
      setSelectedImages(products.map((product) => product.images[0]));
    }
  }, [products]);

  const fetchSizeChart = async () => {
    // If already visible, just hide it
    if (showSizeChart) {
      setShowSizeChart(false);
      return;
    }

    // If image already fetched, just show it
    if (chartImage) {
      setShowSizeChart(true);
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_size_chart_list`,
        {
          admin_auto_id,
          app_type_id,
        }
      );

      if (response.data.status === "1" && response.data.getalldata.length > 0) {
        const img = response.data.getalldata[0].chart_image;
        const imageUrl = `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${img}`;
        const img2 = response.data.getalldata[0].international_size_chart;
        const imageUrl2 = `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${img2}`;
        setChartImage(imageUrl);
        setChartImage2(imageUrl2);
        setShowSizeChart(true);
      } else {
        setMessage("Size chart not available.");
      }
    } catch (error) {
      console.error("Failed to load size chart:", error);
    } finally {
      clearMessage();
      setShowSizeChart(false);
    }
  };


  useEffect(() => {

    const fetchProducts = async () => {
      try {
        const adminId = sessionStorage.getItem("admin_auto_id");
        const appTypeId = sessionStorage.getItem("app_type_id");
        const accessToken = sessionStorage.getItem("accessToken");
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_new_product_list`,
          {
            admin_auto_id: adminId,
            app_type_id: appTypeId,
            component_auto_id: data._id,
            component_type: "Recommended",
            limit: 6,
            page_number: 1,
            customer_auto_id: accessToken || adminId,
          }
        );

        if (
          response.data.status === 1 &&
          Array.isArray(response.data.get_products_lists) &&
          response.data.get_products_lists.length > 0
        ) {
          setCommonSubCategoryAutoId(
            response.data.get_products_lists[0].sub_category_auto_id
          );

          setCommonSubCategoryName(
            "Shop Now"
          );
          const formattedProducts = response.data.get_products_lists.map(
            (product) => ({
              id: product.product_auto_id,
              name: product.product_name,
              price: `${product.final_product_price || "0.00"}`,
              originalPrice: product.product_price
                ? `₹${product.product_price}`
                : undefined,
              discount: product.offer_percentage
                ? `${product.offer_percentage}% OFF`
                : undefined,
              reviews: product.total_reviews || 0,
              rating: product.average_rating || 0,

              images: Array.isArray(product.product_images)
                ? product.product_images.map(
                  (img) =>
                    `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${img.product_image}`
                )
                : [],
              user_auto_id: product.user_auto_id,
              size: product.size,
              get_price_lists: product.get_price_lists,
              offer_data: product.offer_data,
              moq: product.moq,
              description: product.description
            })
          );
          setProducts(formattedProducts);
        } else {
          throw new Error("Failed to fetch products");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setThemeColor(parsedStyle.web_theme_colour);
    }
  }, []);

  // Fetch marketing keys
  useEffect(() => {
    const fetchMarketingKeys = async () => {
      setIsMarketingKeysLoading(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_marketing_keys`,
          {
            admin_auto_id,
            app_type_id,
          }
        );

        if (response.data.status === "1" && response.data.data.length > 0) {
          const apiData = response.data.data[0];
          setIsQuantityLeftFactual(apiData.is_quantity_left_factual);
          setQuantityLeftFactualValue(apiData.quantity_left_factual_value);
        } else {
          console.error("Failed to fetch marketing keys:", response.data.msg);
        }
      } catch (error) {
        console.error("Error fetching marketing keys:", error);
      } finally {
        setIsMarketingKeysLoading(false);
      }
    };

    fetchMarketingKeys();
  }, [admin_auto_id, app_type_id]);

  // Set random stocks based on marketing keys
  useEffect(() => {
    if (isMarketingKeysLoading || !selectedProduct) {
      return;
    }

    const shouldShowStock = Math.random() < 0.9;
    setShowStock(shouldShowStock);

    if (shouldShowStock && selectedProduct.size?.length > 0) {
      const stock = parseInt(quantityLeftFactualValue, 10);
      if (isNaN(stock) || stock <= 0) {
        setRandomStocks(selectedProduct.size.map(() => 0));
      } else {
        const newRandomStocks = selectedProduct.size.map(() =>
          Math.floor(Math.random() * stock) + 1
        );
        setRandomStocks(newRandomStocks);
      }
    } else {
      const originalStocks = selectedProduct.size.map((size) =>
        parseInt(size.size_stock, 10)
      );
      setRandomStocks(originalStocks);
    }
  }, [isMarketingKeysLoading, selectedProduct, quantityLeftFactualValue]);

  const [selectedImages, setSelectedImages] = useState(
    products.map((product) => product.images[0]) // Default to the first image of each product
  );

  const handleThumbnailClick = (productIndex, image) => {
    const updatedImages = [...selectedImages];
    updatedImages[productIndex] = image; // Update the selected image for that product
    setSelectedImages(updatedImages);
  };
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const openSidebar = (product) => {
    setSelectedProduct(product);
    setSidebarOpen(true);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
    setSelectedProduct(null);
  };
  if (loading || products.length === 0) {
    return null;
  }
  const handleShopNow = () => {
    navigate("/productlist", {
      state: {
        sub_cat_id: commonSubCategoryAutoId,
        subcategoryName: commonSubCategoryName
      },
    });
  };

 return (
     <div
       className={`mx-2 rounded-lg mb-2 p-1 ${data.web_title_font}`}
       style={{
         backgroundColor: data.web_background_color,
       }}
     >
       <style>{styles}</style>
       <h2
         className={`text-3xl font-bold text-${data.title_alignment} ${data.web_title_font}`}
         style={{ color: data.web_title_color }}
       >
         {data.title}
       </h2>
 
 
       <div className="grid grid-cols-1 gap-6 mt-6 lg:grid-cols-4">
         {/* Left Section */}
         <div
           className="relative w-full h-full overflow-hidden rounded-lg lg:col-span-1"
           style={{ backgroundColor: themeColor }}
         >
           {/* Button over image */}
           <button
             className="absolute z-10 px-4 py-2 text-white transform -translate-x-1/2 bg-black rounded-lg bottom-4 left-1/2"
             onClick={handleShopNow}
           >
             Shop Now
           </button>
 
           {/* Full-size background image */}
           <img
             src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/slider/${data.background_image}`}
             alt="Featured"
             className="object-cover w-full h-full"
           />
         </div>
 
 
         {/* Right Section (Products) */}
         <div className="relative p-1 lg:col-span-3">
           <Swiper
             ref={swiperRef2}
             modules={[Navigation]}
             spaceBetween={20}
             slidesPerView={1}
             navigation={{
               nextEl: `.custom-next-${data._id}`,
               prevEl: `.custom-prev-${data._id}`,
             }}
             breakpoints={{
               0: { slidesPerView: 1.2 },
               640: { slidesPerView: 2 },
               1024: { slidesPerView: 4 },
             }}
           >
             {products.map((product, index) => (
               <SwiperSlide
                 key={index}
                 onMouseEnter={() => setHoveredIndex(index)}
                 onMouseLeave={() => setHoveredIndex(null)}
               >
                 <Link
                   to={`/product-detail/${product.id}`}
                   className="no-underline text-inherit"
                 >
                   <div className="relative p-1 bg-white border rounded-lg ">
                     <div className="relative">
                       {/* Discount Badge */}
                       {product.discount &&
                         parseFloat(product.discount.replace("% off", "")) >
                         0 && (
                           <span className="absolute z-10 px-2 py-1 text-xs font-bold text-white rounded top-2 left-2"
                             style={{ backgroundColor: themeColor }}>
                             {product.discount}
                           </span>
                         )}
 
                       {/* Internal Swiper for product images */}
                       <Swiper
                         modules={[Navigation]}
                         navigation={{
                           nextEl: `.next-${index}`,
                           prevEl: `.prev-${index}`,
                         }}
                         className="relative"
                       >
                         {product.images.map((img, imgIndex) => (
                           <SwiperSlide key={imgIndex}>
                             <img
                               src={selectedImages[index]} // Display selected image
                               alt={`Product ${index}`}
                               className="object-cover w-full rounded-lg h-72"
                             />
                           </SwiperSlide>
                         ))}
                       </Swiper>
                       {/* Choose Size Button (Visible on Hover) */}
                       {hoveredIndex === index && (
                         <button
                           className="absolute z-50 px-4 py-1 font-semibold text-white transform -translate-x-1/2 rounded-lg shadow-lg bottom-4 left-1/2"
                           style={{ backgroundColor: themeColor }}
                           onClick={(e) => {
                             e.stopPropagation();
                             e.preventDefault();
                             openSidebar(product);
                           }}
                         >
                           Choose Options
                         </button>
                       )}
 
                       {/* Internal navigation buttons for product images (Unique per product) */}
                       {/* <div
                       className={`absolute top-1/2 left-2 transform -translate-y-1/2 z-10 cursor-pointer prev-${index}`}
                     >
                       <FaArrowLeft className="p-1 text-xl text-black rounded-full" />
                     </div>
                     <div
                       className={`absolute top-1/2 right-2 transform -translate-y-1/2 z-10 cursor-pointer next-${index}`}
                     >
                       <FaArrowRight className="p-1 text-xl text-black rounded-full" />
                     </div> */}
                     </div>
                     {/* Sidebar Popup */}
                     {/* Sidebar Popup (Body Level) */}
 
                     <h3 className="mt-4 text-sm font-semibold">
                       {product.name.length > 20
                         ? product.name.substring(0, 20) + "..."
                         : product.name}
                     </h3>
                     {/* <p className="flex items-center mt-2 text-green-600">
                       Includes a FREE $29.99 Keychain 🎁
                     </p> */}
 
                     <div className="flex items-center mt-2 text-yellow-400">
                       {Array.from({ length: 5 }, (_, i) => (
                         <FaStar
                           key={i}
                           className={i < product.rating ? "" : "text-gray-300"}
                         />
                       ))}
                       <span className="ml-2 text-gray-600">
                         {product.reviews} reviews
                       </span>
                     </div>
 
                     <div className="flex items-center justify-start mt-2">
                       <span className="font-bold text-red-600">
                         {product.price}
                       </span>
 
                       <span className="pl-2 text-gray-500 line-through text-md">
                         {product.discount &&
                           parseFloat(product.discount.replace("% off", " ")) > 0
                           ? product.originalPrice
                           : ""}
                       </span>
                     </div>
 
                     {/* Thumbnails: Click to Change Main Image */}
                     <div className="grid grid-cols-6 gap-1 mt-4">
                       {product.images.map((img, imgIndex) => (
                         <img
                           key={imgIndex}
                           src={img}
                           alt={`Product ${index}`}
                           className={`w-7 h-7 object-cover rounded-full cursor-pointer ${selectedImages[index] === img
                             ? "border-2 border-blue-500"
                             : ""
                             }`}
                           onClick={(e) => {
                             e.stopPropagation();
                             e.preventDefault();
                             handleThumbnailClick(index, img);
                           }}
                         />
                       ))}
                     </div>
                   </div>
                 </Link>
               </SwiperSlide>
             ))}
           </Swiper>
 
           <div className="absolute z-10 flex justify-between w-full px-4 -translate-y-1/2 top-1/2">
             <div className={`custom-prev-${data._id} cursor-pointer`}>
               <FaArrowLeft className="p-1 text-3xl text-black bg-white rounded-full shadow" />
             </div>
             <div className={`custom-next-${data._id} cursor-pointer`}>
               <FaArrowRight className="p-1 text-3xl text-black bg-white rounded-full shadow" />
             </div>
           </div>
         </div>
       </div>
 
       {/* Sidebar Popup (Full Screen) */}
       {isSidebarOpen && (
         <>
           <div className="fixed inset-0 z-40 flex justify-end bg-opacity-30 backdrop-blur-sm">
             <div className="w-full sm:w-[500px] h-full bg-white shadow-lg transform transition-transform z-50 flex flex-col">
               {/* Header with title and close button */}
               <div className="flex items-center justify-between px-4 py-3">
                 <p
                   className="mb-0 text-lg font-bold text-black"
 
                 >
                   CHOOSE OPTION
                 </p>
                 <button
                   className="text-xl text-gray-500"
                   onClick={closeSidebar}
                 >
                   <LiaTimesSolid />
                 </button>
               </div>
 
 
               {/* Horizontal divider */}
               <div className="w-full h-px bg-gray-400"></div>
               <div className="relative flex-1 py-3 pl-10 pr-3 overflow-y-auto">
                 {/* Product Image Slider */}
                 <Swiper
                   slidesPerView={2.5}
                   spaceBetween={10}
                   loop={selectedProduct.images && selectedProduct.images.length > 2}
                   pagination={{ clickable: true }}
 
                   className="mt-3 mb-3"
                 >
                   {selectedProduct.images && selectedProduct.images.length > 0 ? (
                     selectedProduct.images.map((image, index) => (
                       <SwiperSlide key={index}>
                         <img
                           src={image}
                           alt={`${selectedProduct.name} ${index + 1}`}
                           className="object-cover w-full h-72 "
                         />
                       </SwiperSlide>
                     ))
                   ) : (
                     <SwiperSlide>
                       <img
                         src="https://placehold.co/600x400"
                         alt="No image available"
                         className="object-cover w-full rounded-lg h-60"
                       />
                     </SwiperSlide>
                   )}
                 </Swiper>
 
                 <h2 className="text-lg font-bold truncate">{selectedProduct.name}</h2>
                 <p className="mt-2 text-gray-600 truncate">{selectedProduct.description}</p>
                 <div className="flex items-center justify-start mt-1">
                   <span className="mr-3 text-lg font-semibold">
                     {`Rs. ${selectedSizePrice ? selectedSizePrice : selectedProduct.price
                       }`}
                   </span>
                   {selectedProduct.discount &&
                     parseFloat(selectedProduct.discount.replace("% off", "")) >
                     0 && (
                       <span className="text-sm text-gray-500 line-through">
                         {selectedProduct.originalPrice}
                       </span>
                     )}
                 </div>
 
                 {/* Size Selection */}
                 {selectedProduct.size?.length > 0 && (
                   <>
                     <div className="mt-3">
                       <div className="flex items-center justify-between ">
                         <label className="font-bold">Select</label>
                         {/* Size Chart Toggle */}
                         {(chartImage || chartImage2) && (
                           <div className="text-end">
                             <button
                               className="flex items-center justify-end gap-1 mt-2 text-black"
                               onClick={fetchSizeChart}
                             >
 
                               <TfiRulerAlt className="text-base" />
                               {showSizeChart ? (
                                 <span className="underline">Size Chart</span>
                               ) : (
                                 <>
                                   <span className="underline">Size Chart</span>
                                 </>
                               )}
                             </button>
                           </div>
                         )}
 
                       </div>
 
                       <div className="flex gap-2 mt-2">
                         {Array.isArray(selectedProduct?.size) &&
                           selectedProduct.size.map((sizeObj, index) => {
                             const actualStock = parseInt(sizeObj.size_stock, 10);
                             const isDisabled =
                               !actualStock || isNaN(actualStock) || actualStock <= 0;
                             const isSelected = selectedSize === sizeObj.size_name;
                             const displayStock = showStock
                               ? randomStocks[index]
                               : actualStock;
                             const showStockLabel =
                               actualStock > 0 &&
                               showStock &&
                               isQuantityLeftFactual &&
                               displayStock <= 5;
 
                             return (
                               <div key={sizeObj.size_auto_id} className="relative">
                                 <button
                                   className={`relative border w-20 h-12 rounded-full text-sm flex items-center justify-center flex-col transition-colors duration-200 overflow-hidden
                                             ${isDisabled ? "bg-gray-200 text-gray-400 border-gray-300 cursor-not-allowed disabled-overlay" : ""}
                                             ${!isDisabled && isSelected ? "text-white" : ""}`}
                                   style={{
                                     backgroundColor:
                                       !isDisabled && isSelected ? themeColor : undefined,
                                     borderColor:
                                       !isDisabled && isSelected ? themeColor : undefined,
                                     color: !isDisabled && isSelected ? "#ffffff" : undefined,
                                   }}
                                   onClick={() => {
                                     if (isDisabled) return;
                                     setSelectedSize(sizeObj.size_name);
                                     setSelectedSizeId(sizeObj.size_auto_id);
                                     setSelectedStock(actualStock);
                                     const sizePriceObj =
                                       selectedProduct.get_price_lists[index];
                                     if (
                                       !sizePriceObj ||
                                       !sizePriceObj.final_size_price
                                     ) {
                                       setMessage("Size price not available");
                                       clearMessage();
                                       return;
                                     }
                                     setSelectedSizePrice(sizePriceObj.final_size_price);
                                   }}
                                   onMouseEnter={(e) => {
                                     if (!isSelected && !isDisabled) {
                                       e.currentTarget.style.backgroundColor = themeColor;
                                       e.currentTarget.style.color = "#ffffff";
                                     }
                                   }}
                                   onMouseLeave={(e) => {
                                     if (!isSelected && !isDisabled) {
                                       e.currentTarget.style.backgroundColor = "#ffffff";
                                       e.currentTarget.style.color = "#000000";
                                     }
                                   }}
                                   disabled={isDisabled}
                                 >
                                   <span
                                     className={`text-base leading-none ${showStockLabel ? "mb-3" : ""
                                       }`}
                                   >
                                     {sizeObj.size_name}
                                   </span>
                                   {showStockLabel && (
                                     <span
                                       className="absolute bottom-0 left-0 right-0 px-2 py-[4px] text-[11px] text-center text-white leading-tight"
                                       style={{ backgroundColor: themeColor }}
                                     >
                                       {displayStock} left
                                     </span>
                                   )}
                                 </button>
                               </div>
                             );
                           })}
                       </div>
                     </div>
 
 
 
                     {showSizeChart && chartImage && (
                       <div className="p-2 mt-2 border rounded-lg">
                         <h3 className="mb-2 text-lg font-bold">Size Chart</h3>
                         <img
                           src={chartImage}
                           alt="Size Chart"
                           className="w-full h-auto rounded"
                         />
 
                         <h3 className="mb-2 text-lg font-bold">
                           {" "}
                           International Size Chart
                         </h3>
                         <img
                           src={chartImage2}
                           alt="Size Chart"
                           className="w-full h-auto rounded"
                         />
                       </div>
                     )}
                   </>
                 )}
 
 
                 <div className="relative mt-5">
 
                   {message && (
                     <div
                       className="p-2 mt-2 text-sm text-center bg-white "
                       style={{
                         color: message.includes("successfully") ? "green" : "red",
                       }}
                     >
                       {message}
                     </div>
                   )}
                   {/* Flex container for quantity control and add to cart button */}
                   <div className="flex flex-row items-center gap-1">
 
                     {/* Quantity Control */}
                     <div className="flex items-center">
                       <button
                         className="bg-white px-2 py-[12px] border-l-2 border-t-2 border-b-2 border-gray-200   rounded-l-full"
                         onClick={() => setQuantity(Math.max(1, quantity - 1))}
                       >
                         <FaMinus />
                       </button>
                       <input
                         type="number"
                         min="1"
                         value={quantity}
                         onChange={(e) => {
                           const value = Math.max(1, parseInt(e.target.value));
                           setQuantity(value);
                         }}
                         className="w-11 text-center border-t-2 border-b-2 border-gray-200  py-[8px] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none appearance-none " />
                       <button
                         className="bg-white px-2 py-[12px] border-r-2 border-t-2 border-b-2  border-gray-200 rounded-r-full"
                         onClick={() => setQuantity(quantity + 1)}
                       >
                         <FaPlus />
                       </button>
                     </div>
 
                     {/* Add to Cart Button */}
                     <button
                       className={`flex-1 text-white py-[12px] rounded-full border ${selectedProduct.size?.length > 0 && (!selectedSize || selectedStock === 0)
                         ? "bg-gray-400 cursor-not-allowed"
                         : "cursor-pointer"
                         }`}
                       style={{
                         backgroundColor:
                           selectedProduct.size?.length > 0 && (!selectedSize || selectedStock === 0)
                             ? "#ccc"
                             : themeColor,
                       }}
                       onMouseEnter={(e) => {
                         if (!(selectedProduct.size?.length > 0 && (!selectedSize || selectedStock === 0))) {
                           const darkenedColor = darkenHexColor(themeColor, 0.15);
                           e.currentTarget.style.backgroundColor = darkenedColor;
                         }
                       }}
                       onMouseLeave={(e) => {
                         e.currentTarget.style.backgroundColor =
                           selectedProduct.size?.length > 0 && (!selectedSize || selectedStock === 0)
                             ? "#ccc"
                             : themeColor;
                       }}
                       onClick={async (e) => {
                         e.preventDefault();
                         e.stopPropagation();
                         setMessage(null);
 
                         const moq = parseInt(selectedProduct?.moq || "1", 10);
                         const qty = parseInt(quantity, 10);
 
                         if (
                           selectedProduct.size?.length !== 0 &&
                           (!selectedSize || !selectedSizePrice)
                         ) {
                           setMessage("Please select a size");
                           clearMessage();
                           return;
                         }
 
                         if (selectedProduct.size?.length !== 0 && selectedStock === 0) {
                           setMessage("Selected size is out of stock");
                           clearMessage();
                           return;
                         }
 
                         if (qty < moq) {
                           setMessage(`Minimum order quantity is ${moq}`);
                           clearMessage();
                           return;
                         }
 
                         const payload = {
                           product_auto_id: selectedProduct.id,
                           added_by_id: selectedProduct.user_auto_id,
                           cart_quantity: qty,
                           ...(selectedProduct.size?.length !== 0 && {
                             size: selectedSizeId,
                             size_price: selectedSizePrice,
                           }),
                         };
 
                         try {
                           const res = await addToCart(payload);
                           await getCartCount();
 
                           if (res?.status === "1") {
                             setMessage(res.message);
                             clearMessage();
                             setTimeout(() => {
                               navigate("/cart");
                             }, 1000);
                           } else {
                             setMessage(res.message);
                             clearMessage();
                           }
                         } catch (error) {
                           setMessage(error.message);
                           clearMessage();
                           console.log("Failed to add to cart -", error);
                         }
                       }}
                     >
                       {selectedProduct.size?.length === 0
                         ? `Add to Cart | ₹ ${selectedProduct.price}`
                         : !selectedSize
                           ? "SELECT A SIZE"
                           : selectedStock === 0
                             ? "Size Out of Stock"
                             : `Add to Cart | ₹ ${selectedSizePrice}`}
                     </button>
                   </div>
 
 
                   <div className="mt-4 text-center">
                     <Link
                       to={`/product-detail/${selectedProduct.id}`}
                       className="text-inherit"
                     >
                       <button className="text-black underline ">View Details</button>
                     </Link>
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </>
       )}
     </div>
   );
};

export default Recommended2;
